module.exports = __webpack_public_path__ + "static/media/signature.5eb64937.png";